import { render, staticRenderFns } from "./TemporaryDeliveryModal.vue?vue&type=template&id=c2146930&scoped=true"
import script from "./TemporaryDeliveryModal.vue?vue&type=script&lang=ts"
export * from "./TemporaryDeliveryModal.vue?vue&type=script&lang=ts"
import style0 from "./TemporaryDeliveryModal.vue?vue&type=style&index=0&id=c2146930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2146930",
  null
  
)

export default component.exports